// SETTINGS V2 — phone sheet identity row (SP1.1 / Q-SETV2-5 = B).
//
// Avatar initials + full name at the top of the phone nav sheet, for
// orientation. NO email (hard rule). Same data source + initials rule as the
// desktop rail user-header (SettingsV2Rail.tsx): reads customerAccount.userInfo
// (the SAME slice — no new fetch; getAccount runs once in the layout), '?' only
// when userInfo is null, name rendered raw.
//
// A non-interactive header (plain div/spans — no NavLink/button) so it stays out
// of the sheet's Tab focus trap and never reads as a 44px nav row. Scoped
// CSS-var tokens + inline styles only — no MUI/sx/dt/Tailwind.
import React from "react";

import { useAppSelector } from "../../../../shared/hooks/sharedHooks";

const SettingsV2SheetIdentity: React.FC = () => {
  const userInfo = useAppSelector((s) => s.customerAccount.userInfo);
  const initials = userInfo
    ? `${(userInfo.firstName || "").charAt(0)}${(userInfo.lastName || "").charAt(0)}`.toUpperCase()
    : "?";
  const displayName = userInfo
    ? `${userInfo.firstName} ${userInfo.lastName}`
    : "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "2px 8px 10px",
        marginBottom: 2,
        borderBottom: "1px solid var(--border-soft)",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 34,
          height: 34,
          borderRadius: 999,
          background: "var(--mod-accent)",
          color: "#fff",
          display: "grid",
          placeItems: "center",
          fontSize: 12.5,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {initials}
      </span>
      <span
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: "var(--ink)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {displayName}
      </span>
    </div>
  );
};

export default SettingsV2SheetIdentity;
